export default __webpack_public_path__ + "static/media/iconlogin.2c24b4f4.png";